import { createContext } from 'react';

export const UseContext = createContext("");